var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['main-wrapper', _vm.computedClasses]},[(_vm.isLoading)?[_c('app-header',{attrs:{"is-show-info":false}}),_c('loading')]:_c('router-view'),_c('app-footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }